import { EMAILRECOVERY_GET, EMAILRECOVERY_UPDATE } from './reduxConstant';
import { createReducer } from '../../../../App/common/utilities/reducerUtils';

const initialState = {
  email: null,
  setAsUsername: false,
  startTime: null,
};

const emailRecoveryGet = (state, payload) => {
  return { ...payload.emailRecovery };
};

const emailRecoveryUpdate = (state, payload) => {
  return { ...state, ...payload.emailRecovery };
};

export default createReducer(initialState, {
  [EMAILRECOVERY_GET]: emailRecoveryGet,
  [EMAILRECOVERY_UPDATE]: emailRecoveryUpdate,
});
